export default __webpack_public_path__ + "static/media/fa-solid-900.7eefe04d.eot";